{
  "ModalTitleMc": "Effettuare una chiamata",
  "ModalTitleTo": "Inviare la chiamata a",
  "ModalTitleMcc": "Richiesta di trasferimento a",
  "SubTitle": "Scegliere il numero di telefono",
  "SelectLabel": "Numero di telefono",
  "SelectPlaceholder": "ad esempio 01234567899",
  "SelectNoItems": "Numero sconosciuto",
  "FooterHelp": "Aiuto",
  "FooterOk": "OK",
  "FooterClose": "Chiudere",
  "CallTargetting_Description": "Selezionare un dispositivo di destinazione interno dall'elenco o inserire manualmente il numero di telefono di destinazione.",
  "NAME": "CallTargetting"
}